import axios from 'axios'
import {apiDomain} from '../../config'

export default {
	get_receipts_wo_hauls (filter_by) {
		return new Promise((resolve, reject) => {
			axios.post(apiDomain + '/receipts_wo_hauls/', filter_by,{ headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					var data = ''
					data = response.data
					resolve(data)
		        })
		        .catch((error) => {
		          	reject(error)
		        })
		})
	},
	get_altex_hauls () {
		return new Promise((resolve, reject) => {
			axios.get(apiDomain + '/altex_check/', { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					var data = ''
					data = response.data
					resolve(data)
		        })
		        .catch((error) => {
		          	reject(error)
		        })
		})
	},
	get_petrotranz_hauls (filter_by) {
		return new Promise((resolve, reject) => {
			axios.post(apiDomain + '/petrotranz_reports/', filter_by, { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					var data = ''
					data = response.data
					resolve(data)
		        })
		        .catch((error) => {
		          	reject(error)
		        })
		})
	},
}



// WEBPACK FOOTER //
// ./src/views/receipt/receipt_service.js